import { createStore } from '@stencil/store';
import { EMPTY, Subscription, catchError } from 'rxjs';
import { docData } from 'rxfire/firestore';
import { doc } from 'firebase/firestore';

import { FirebaseService } from '../utils/firebase';
import { closeSnackbar, openSnackbar } from '../modals/snackbar.modal';
import packageJson from '../../package.json';

import { SystemInfo } from '@artask/tambr-models/models/system.model';



interface VersionState {
  version: string;
  versionSubscription: Subscription;
}

const { state, reset, onChange } = createStore<VersionState>({
  version: null,
  versionSubscription: null
});

function startVersionListener() {
  state.versionSubscription = docData( 
    doc( FirebaseService.firestore, 'system/info' )
  ).pipe(
    catchError( error => {
      console.log( 'Error fetching app version:', error );
      return EMPTY;
    })
  ).subscribe( (systemInfo: SystemInfo) => {
    state.version = systemInfo?.widgetVersion ?? null;
  });

  onChange( 'version', version => {
    if ( version !== null && version > packageJson.version ) {
      openSnackbar( 'New version is available. ', 'success', 0, 'bottom-left', 'Refresh the page', () => window.location.reload() );
    } else {
      console.log( 'No new version available' );
      closeSnackbar();
    }
  });
}

function stopVersionListener() {
  if ( state.versionSubscription ) state.versionSubscription.unsubscribe();
  reset();
}

export { 
  startVersionListener, 
  stopVersionListener
};